"use client";
import { HStack, Icon, IconButton } from "@chakra-ui/react";
import { LuFacebook, LuLinkedin } from "react-icons/lu";
import { FaLink } from "react-icons/fa6";
import { FacebookShareButton, LinkedinShareButton } from "react-share";
import { toaster } from "@/_components/lib/ui/toaster";
import "./share.css";
import {
  BIEvents,
  useTimingEvent,
} from "@/_components/lib/mixpanel/mixpanelClient";
import { useEffect } from "react";

interface BlogShareBtnProps {
  title: string;
  url: string;
}
export const BlogShareBtns = ({ title, url }: BlogShareBtnProps) => {
  const { startTrack, stopTrack } = useTimingEvent(
    BIEvents.BLOG_STAY_ON_ARTICLE,
    {
      title,
      url,
    },
  );

  useEffect(() => {
    startTrack();
    return () => {
      stopTrack();
    };
  }, []);

  const handleCopyLink = () => {
    const urlToCopy =
      typeof window !== "undefined" ? window.location.href : url;

    const textArea = document.createElement("textarea");
    textArea.value = urlToCopy;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, 99999);

    try {
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        toaster.success({
          title: "Link copied!",
          description: "The blog post URL has been copied to your clipboard.",
        });
      } else {
        throw new Error("execCommand failed");
      }
    } catch {
      document.body.removeChild(textArea);

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(urlToCopy).then(
          () => {
            toaster.success({
              title: "Link copied!",
              description:
                "The blog post URL has been copied to your clipboard.",
            });
          },
          () => {
            toaster.error({
              title: "Failed to copy",
              description:
                "Unable to copy the link to clipboard. Please try again.",
            });
          },
        );
      } else {
        toaster.error({
          title: "Failed to copy",
          description:
            "Unable to copy the link to clipboard. Please try again.",
        });
      }
    }
  };

  return (
    <HStack gap={4}>
      <IconButton
        // boxSize={14}
        _hover={{ transform: "scale(1.1)", shadow: "md" }}
        size="sm"
        bg="white"
        borderRadius="full"
        boxShadow="shadow-sm"
        color="indigoCustom.500"
        onClick={handleCopyLink}
        aria-label="Copy link to clipboard"
      >
        <Icon as={FaLink} color="inherit" boxSize={4} />
      </IconButton>
      <IconButton
        // boxSize={14}
        _hover={{ transform: "scale(1.1)", shadow: "md" }}
        size="sm"
        bg="white"
        borderRadius="full"
        boxShadow="shadow-sm"
        color="indigoCustom.500"
        onClick={handleCopyLink}
        aria-label="Copy link to clipboard"
      >
        <FacebookShareButton url={url} className="share-button-fb">
          <Icon as={LuFacebook} color="inherit" boxSize={4} />
        </FacebookShareButton>
      </IconButton>
      <IconButton
        // boxSize={14}
        _hover={{ transform: "scale(1.1)", shadow: "md" }}
        size="sm"
        bg="blue.500"
        borderRadius="full"
        boxShadow="shadow-sm"
        color="white"
        onClick={handleCopyLink}
        aria-label="Copy link to clipboard"
      >
        <LinkedinShareButton url={url} className="share-button-ln">
          <Icon as={LuLinkedin} color="inherit" boxSize={4} />
        </LinkedinShareButton>
      </IconButton>
    </HStack>
  );
};
